<h2 class="all-categories-title text-center mb-4">{{ 'ALL_CATEGORIES' | translate }}</h2>

<div *ngIf="loading" class="text-center my-5">
  <i class="fa fa-spinner fa-spin fa-3x"></i>
</div>

<section *ngFor="let group of groups" class="all-categories-group mb-4">
  <h3 class="all-categories-band">
    <a [routerLink]="['/articles', group.assortment.id]">{{ getMainCategoryName(group.assortment) }}</a>
  </h3>
  <div class="row">
    <div *ngFor="let child of group.children" class="col-12 col-sm-6 col-md-3 col-lg-2 mb-2">
      <div
        class="card card-assortment-tree h-100 card-border-top"
        [class.card-border-top-blue]="!isActiveInB2B(child)"
      >
        <a
          *ngIf="isAssortmentManager && !pimEditUrlHide"
          class="pim-edit"
          [href]="assortmentPimUrl + child.id?.substring(1)"
          target="_blank"
          (click)="$event.stopPropagation()"
        >
          <i class="fa-regular fa-pen-to-square"></i>
        </a>
        <a [routerLink]="['/articles', group.assortment.id, child.id]" class="border-0 h-100 d-flex flex-column">
          <img
            *ngIf="child.extra?.images && child.extra.images[0] as image; else noimage"
            class="card-img-top img-fluid mx-auto d-block"
            src="https://cdn1.gung.io/fit-in/350x350/filters:fill(white):background_color(white):etag({{
              image.s3ETag
            }}):format(jpeg)/{{ image.s3Uri }}"
            alt="{{ image.description }}"
          />
          <ng-template #noimage>
            <img
              class="card-img-top img-fluid mx-auto d-block"
              src="https://cdn1.gung.io/fit-in/300x300/images/no-image.jpg"
              alt="NO IMAGE"
            />
          </ng-template>
          <div class="card-body d-flex">
            <div class="card-title w-100 d-flex align-items-center justify-content-between text-break">
              <span>{{ child | productName }}</span>
              <i class="fa fa-angle-right align-self-end" aria-hidden="true" style="font-size: x-large"></i>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</section>
